export default __webpack_public_path__ + "static/share-022e61bff1f72a8b312edf5d0c08e1ce.jpg";